import { render } from "./academy.vue?vue&type=template&id=43f54954"
import script from "./academy.vue?vue&type=script&lang=js"
export * from "./academy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__